import { baseEnv } from './environment.base';

export const environment = {
  ...baseEnv,
  ...{
    production: true,
    name: 'development',

    backendUrl: 'https://zbackend.stasi.cc',
    UIsUrl: 'https://reporting.stasi.cc',

    domain: '.stasi.cc',

    // LCP api
    lcpApiUrl: 'https://experience-room.appspot.com/v1'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts